// extracted by mini-css-extract-plugin
export default {"atsOfferTitleContainer":"BbVdDBKt4laCSw_TLGQm","atsId":"NX0vSBP7Nm_bPxxxNDpB"};